export default __webpack_public_path__ + "static/media/Flag_of_Bosnia_and_Herzegovina.aedb4fa8.svg";